import apiFetch from '../apiFetch'

//export default function (arrayIdAlbaran) {    
export default function (values, token) {    
  //return apiFetch({endPoint: `Albaran/imprimirMultiplesAlbaranes?arrayIdAlbaran=${arrayIdAlbaran}`, method: 'GET'})
  return apiFetch({endPoint: `Albaran/imprimirMultiplesAlbaranes`, method: 'POST', body: values, token: token})
}